export default ['api', function (api) {
    return {
        save: (basketCode, guests) => {
            return api.post('guests', {
                basket: basketCode,
                guests: guests
            })
                .then(response => response.data);
        },
        getLeadGuest: (basketCode) => {
            return api.post('api/getLeadGuest', { basketCode: basketCode })
                .then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/guest/services/guest.api.service.js